import { render, staticRenderFns } from "./ListArticle.vue?vue&type=template&id=10af771f&scoped=true"
import script from "./ListArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListArticle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListArticle.vue?vue&type=style&index=0&id=10af771f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af771f",
  null
  
)

export default component.exports